module.exports = __webpack_public_path__ + "static/media/embassy-suites.e17fd154.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/embassy-suites.jpg
// module id = 856
// module chunks = 0